import { ICommand, IDefineCommand } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
import { IDatasource, ORM } from 'utility-ts-orm';
import { Conversation } from '../../src/builders/conversation_builder';
import { IConversationDatasourceModel, IConversationsData } from '../conversations_interface';
import { ConversationFilterStrategy } from '../strategies/conversation_filter_strategy';

angular
  .module('capability-ng-conversations')
  .service(
    'loadConversationsCommand',
    (
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      ngConversationDatastore: IDatasource<Conversation, IConversationDatasourceModel>,
      accountModel: AccountModel,
      loadAccountCommand: ICommand,
      log: any
    ) => {
      return defineCommand(
        'loadConversationsCommand',
        (deferred: ng.IDeferred<IConversationsData>, page: number = 1, filter: string = 'all') => {
          let filterQuery: string = '';
          if (!_4.isEmpty(filter)) {
            filterQuery = `${ConversationFilterStrategy.getByKey(filter).query}&`;
          }

          const loadConversations = () => {
            $http
              .get(`notification/students/${accountModel.student_nk}/messages/?${filterQuery}page=${page}`)
              .then(({ data }: { data: IConversationsData }) => {
                if (filter !== ngConversationDatastore.model.filter) {
                  ngConversationDatastore.clear();
                }
                ngConversationDatastore.write(data.results);
                ngConversationDatastore.includeModel({
                  unreadCount: data.unread,
                  nextPageURL: data.next,
                  page,
                  filter
                });
                ORM.run(ngConversationDatastore);
                deferred.resolve(data);
              })
              .catch((error) => {
                log.issue('Failed to load conversations!');
                deferred.reject(error);
              });
          };

          _4.isEmpty(accountModel.student_nk)
            ? loadAccountCommand().then(() => loadConversations())
            : loadConversations();
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/commands/load_conversations_command.ts